import { SubAPI } from "./SubAPI";
export class Extractor extends SubAPI {
    session(input, onProgress) { return this.fetcher.postFormDataWithProgress("/api/extractor/session", { file: input.file }, onProgress); }
    sessionStatus(input) { return this.fetcher.get("/api/extractor/session/status", input); }
    imageURL(input) { const params = new URLSearchParams(); params.append("session", input.session.toString()); params.append("index", input.index.toString()); return "/api/extractor/session/image?" + params.toString(); }
    analyze(input) { return this.fetcher.post("/api/extractor/analyze", input); }
    analyzeStatus(input) { return this.fetcher.get("/api/extractor/analyze/status", input); }
    downloadURL(input) { const params = new URLSearchParams(); params.append("id", input.id); return "/api/extractor/analyze/result?" + params.toString(); }
}
